export const APP_NAME = 'RAemRegularInvestmentCalculator'
export const MIN_PERCENT = 33

export const RF_AMOUNT_INPUTS = {
  AMOUNT_INPUT: 'RIA_AMOUNT_INPUT',
  AMOUNT_MINUS: 'RIA_AMOUNT_MINUS',
  AMOUNT_PLUS: 'RIA_AMOUNT_PLUS',
  AMOUNT_SLIDER: 'RIA_AMOUNT_SLIDER',
  DURATION_INPUT: 'RIA_DURATION_INPUT',
  DURATION_MINUS: 'RIA_DURATION_MINUS',
  DURATION_PLUS: 'RIA_DURATION_PLUS',
  DURATION_SLIDER: 'RIA_DURATION_SLIDER',
  ADD_EXTRA_EXTRA_DEPOSIT: 'RIA_ADD_EXTRA_DEPOSIT',
  REMOVE_EXTRA_EXTRA_DEPOSIT: 'RIA_REMOVE_EXTRA_EXTRA_DEPOSIT',
  DEPOSIT_INPUT: 'RIA_DEPOSIT_INPUT',
}

export const RF_INVESTOR_TYPE_INPUT = {
  LIST: 'RI_INPUT_LIST',
  CONSERVATIVE: 'RI_INPUT_CONSERVATIVE',
  BALANCED: 'RI_INPUT_BALANCED',
  DYNAMIC: 'RI_INPUT_DYNAMIC',
  AGGRESSIVE: 'RI_INPUT_AGGRESSIVE',
}

export const RF_SAVINGS_INPUTS = {
  AMOUNT_INPUT: 'RIS_AMOUNT_INPUT',
  AMOUNT_MINUS: 'RIS_AMOUNT_MINUS',
  AMOUNT_PLUS: 'RIS_AMOUNT_PLUS',
  AMOUNT_SLIDER: 'RIS_AMOUNT_SLIDER',
  DURATION_INPUT: 'RIS_DURATION_INPUT',
  DURATION_MINUS: 'RIS_DURATION_MINUS',
  DURATION_PLUS: 'RIS_DURATION_PLUS',
  DURATION_SLIDER: 'RIS_DURATION_SLIDER',
}

export const RF_TABS = {
  AMOUNT: 'RI_AMOUNT_TAB',
  SAVINGS: 'RI_SAVINGS_TAB',
  AMOUNT_INPUTS: 'RI_AMOUNT_INPUTS',
  SAVINGS_INPUTS: 'RI_SAVINGS_INPUTS',
}

export const RF_RESULTS = {
  TARGET: 'RIA_RESULTS_TARGET',
  CUMULATIVE: 'RI_RESULTS_CUMULATIVE',
  ESTIMATE: 'RI_RESULTS_ESTIMATE',
  INTEREST_RATE: 'RI_RESULTS_INTEREST_RATE',
  PRODUCT_NAME: 'RI_PRODUCT_NAME',
}

export const RF_FOLLOW_UP = {
  BRANCH: 'RI_FOLLOW_UP_BRANCH',
  CALL_ME: 'RI_FOLLOW_UP_CALL',
}
